export default "__VITE_ASSET__ba101393__"